import type { Member } from '@wix/ambassador-blog-frontend-adapter-public-v2-post-feed-page/types';
import {
  getCurrentUser,
  isBlocked as getIsBlocked,
  isPrivate as getIsPrivate,
} from '@wix/communities-blog-client-common';
import { useSelector } from '../components/runtime-context';

export type UseAuth = {
  currentUser: Member | null;
  isAuthenticated: boolean;
  isBlocked: boolean;
  isPrivate: boolean;
};

export default function useAuth(): UseAuth {
  const currentUser = useSelector(getCurrentUser);
  const isAuthenticated = !!currentUser;
  const isBlocked = useSelector(getIsBlocked);
  const isPrivate = useSelector(getIsPrivate);

  return {
    currentUser,
    isAuthenticated,
    isBlocked,
    isPrivate,
  };
}
